import(/* webpackMode: "eager", webpackExports: ["BootstrapForm"] */ "/var/www/clients/client1/web9/home/kupcochceszpanel/seo/src/app/(auth)/login/BootstrapForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoginForm"] */ "/var/www/clients/client1/web9/home/kupcochceszpanel/seo/src/app/(auth)/login/LoginForm.tsx");
